/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { AddTruckToCollectionRoundMutation, AddTruckToCollectionRoundMutationVariables } from "@models/graphql";

const defaultAddTruckToCollectionRoundOptions: MutationHookOptions<
    AddTruckToCollectionRoundMutation,
    AddTruckToCollectionRoundMutationVariables
> = {};

export const useAddTruckToCollectionRound = (
    options?: MutationHookOptions<AddTruckToCollectionRoundMutation, AddTruckToCollectionRoundMutationVariables>
) => {
    const [mutation, { data, loading, error }] = useMutation<AddTruckToCollectionRoundMutation, AddTruckToCollectionRoundMutationVariables>(
        GraphQLDocuments.addTruckToCollectionRound
    );

    const addTruckToCollectionRound = async (variables: AddTruckToCollectionRoundMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultAddTruckToCollectionRoundOptions,
                ...options,
                variables
            });

            return {
                data: response.data,
                error: response.errors
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        addTruckToCollectionRound
    };
};
